'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_AppDocumentDataInvoiceForm(number, recipient, originOfGoods, manufacturer, documentaryCredit, currency, paymentTerms, usuance, placeOfReceipt, placeOfLoading, placeOfDelivery, placeOfDischarge, incoterm, vesselOrFlightNumber, lineItems, freightCost, insuranceNumber, insuranceCost, shipmentDate, importer, consignee, issueDate, dueDate, shippingMarks, purchaseOrderReference, harmonizedSystemCode, transportDocumentNumber, voyage, preCarriageVesselOrFlightNumber, measurements, containerNumber, truckNumber, paymentDetails) {
  this.cJ = null;
  this.cK = null;
  this.cY = null;
  this.cW = null;
  this.cR = null;
  this.cD = null;
  this.d0 = null;
  this.da = null;
  this.d4 = null;
  this.d3 = null;
  this.d1 = null;
  this.d2 = null;
  this.cU = null;
  this.db = null;
  this.cI = null;
  this.cF = null;
  this.cV = null;
  this.cG = null;
  this.cL = null;
  this.cT = null;
  this.cP = null;
  this.cH = null;
  this.cE = null;
  this.d7 = null;
  this.d6 = null;
  this.cS = null;
  this.d8 = null;
  this.dc = null;
  this.d5 = null;
  this.cX = null;
  this.cQ = null;
  this.d9 = null;
  this.cZ = null;
  this.cJ = number;
  this.cK = recipient;
  this.cY = originOfGoods;
  this.cW = manufacturer;
  this.cR = documentaryCredit;
  this.cD = currency;
  this.d0 = paymentTerms;
  this.da = usuance;
  this.d4 = placeOfReceipt;
  this.d3 = placeOfLoading;
  this.d1 = placeOfDelivery;
  this.d2 = placeOfDischarge;
  this.cU = incoterm;
  this.db = vesselOrFlightNumber;
  this.cI = lineItems;
  this.cF = freightCost;
  this.cV = insuranceNumber;
  this.cG = insuranceCost;
  this.cL = shipmentDate;
  this.cT = importer;
  this.cP = consignee;
  this.cH = issueDate;
  this.cE = dueDate;
  this.d7 = shippingMarks;
  this.d6 = purchaseOrderReference;
  this.cS = harmonizedSystemCode;
  this.d8 = transportDocumentNumber;
  this.dc = voyage;
  this.d5 = preCarriageVesselOrFlightNumber;
  this.cX = measurements;
  this.cQ = containerNumber;
  this.d9 = truckNumber;
  this.cZ = paymentDetails;
}
export { $c_Lapp_data_AppDocumentDataInvoiceForm as $c_Lapp_data_AppDocumentDataInvoiceForm };
$p = $c_Lapp_data_AppDocumentDataInvoiceForm.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_AppDocumentDataInvoiceForm;
/** @constructor */
function $h_Lapp_data_AppDocumentDataInvoiceForm() {
}
export { $h_Lapp_data_AppDocumentDataInvoiceForm as $h_Lapp_data_AppDocumentDataInvoiceForm };
$h_Lapp_data_AppDocumentDataInvoiceForm.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_data_AppDocumentDataInvoiceForm)) {
    if ((this.cJ === x$0.cJ)) {
      var x = this.cK;
      var x$2 = x$0.cK;
      var $x_31 = ((x === null) ? (x$2 === null) : x.f(x$2));
    } else {
      var $x_31 = false;
    }
    if ($x_31) {
      var x$3 = this.cY;
      var x$4 = x$0.cY;
      var $x_30 = ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      var $x_30 = false;
    }
    if ($x_30) {
      var x$5 = this.cW;
      var x$6 = x$0.cW;
      var $x_29 = ((x$5 === null) ? (x$6 === null) : x$5.f(x$6));
    } else {
      var $x_29 = false;
    }
    if ($x_29) {
      var x$7 = this.cR;
      var x$8 = x$0.cR;
      var $x_28 = ((x$7 === null) ? (x$8 === null) : x$7.f(x$8));
    } else {
      var $x_28 = false;
    }
    if ($x_28) {
      var x$9 = this.cD;
      var x$10 = x$0.cD;
      var $x_27 = ((x$9 === null) ? (x$10 === null) : x$9.f(x$10));
    } else {
      var $x_27 = false;
    }
    if ($x_27) {
      var x$11 = this.d0;
      var x$12 = x$0.d0;
      var $x_26 = ((x$11 === null) ? (x$12 === null) : x$11.f(x$12));
    } else {
      var $x_26 = false;
    }
    if ($x_26) {
      var x$13 = this.da;
      var x$14 = x$0.da;
      var $x_25 = ((x$13 === null) ? (x$14 === null) : x$13.f(x$14));
    } else {
      var $x_25 = false;
    }
    if ($x_25) {
      var x$15 = this.d4;
      var x$16 = x$0.d4;
      var $x_24 = ((x$15 === null) ? (x$16 === null) : x$15.f(x$16));
    } else {
      var $x_24 = false;
    }
    if ($x_24) {
      var x$17 = this.d3;
      var x$18 = x$0.d3;
      var $x_23 = ((x$17 === null) ? (x$18 === null) : x$17.f(x$18));
    } else {
      var $x_23 = false;
    }
    if ($x_23) {
      var x$19 = this.d1;
      var x$20 = x$0.d1;
      var $x_22 = ((x$19 === null) ? (x$20 === null) : x$19.f(x$20));
    } else {
      var $x_22 = false;
    }
    if ($x_22) {
      var x$21 = this.d2;
      var x$22 = x$0.d2;
      var $x_21 = ((x$21 === null) ? (x$22 === null) : x$21.f(x$22));
    } else {
      var $x_21 = false;
    }
    if ($x_21) {
      var x$23 = this.cU;
      var x$24 = x$0.cU;
      var $x_20 = ((x$23 === null) ? (x$24 === null) : x$23.f(x$24));
    } else {
      var $x_20 = false;
    }
    if ($x_20) {
      var x$25 = this.db;
      var x$26 = x$0.db;
      var $x_19 = ((x$25 === null) ? (x$26 === null) : x$25.f(x$26));
    } else {
      var $x_19 = false;
    }
    if ($x_19) {
      var x$27 = this.cI;
      var x$28 = x$0.cI;
      var $x_18 = ((x$27 === null) ? (x$28 === null) : x$27.f(x$28));
    } else {
      var $x_18 = false;
    }
    if ($x_18) {
      var x$29 = this.cF;
      var x$30 = x$0.cF;
      var $x_17 = ((x$29 === null) ? (x$30 === null) : x$29.f(x$30));
    } else {
      var $x_17 = false;
    }
    if ($x_17) {
      var x$31 = this.cV;
      var x$32 = x$0.cV;
      var $x_16 = ((x$31 === null) ? (x$32 === null) : x$31.f(x$32));
    } else {
      var $x_16 = false;
    }
    if ($x_16) {
      var x$33 = this.cG;
      var x$34 = x$0.cG;
      var $x_15 = ((x$33 === null) ? (x$34 === null) : x$33.f(x$34));
    } else {
      var $x_15 = false;
    }
    if ($x_15) {
      var x$35 = this.cL;
      var x$36 = x$0.cL;
      var $x_14 = ((x$35 === null) ? (x$36 === null) : x$35.f(x$36));
    } else {
      var $x_14 = false;
    }
    if ($x_14) {
      var x$37 = this.cT;
      var x$38 = x$0.cT;
      var $x_13 = ((x$37 === null) ? (x$38 === null) : x$37.f(x$38));
    } else {
      var $x_13 = false;
    }
    if ($x_13) {
      var x$39 = this.cP;
      var x$40 = x$0.cP;
      var $x_12 = ((x$39 === null) ? (x$40 === null) : x$39.f(x$40));
    } else {
      var $x_12 = false;
    }
    if ($x_12) {
      var x$41 = this.cH;
      var x$42 = x$0.cH;
      var $x_11 = ((x$41 === null) ? (x$42 === null) : x$41.f(x$42));
    } else {
      var $x_11 = false;
    }
    if ($x_11) {
      var x$43 = this.cE;
      var x$44 = x$0.cE;
      var $x_10 = ((x$43 === null) ? (x$44 === null) : x$43.f(x$44));
    } else {
      var $x_10 = false;
    }
    if ($x_10) {
      var x$45 = this.d7;
      var x$46 = x$0.d7;
      var $x_9 = ((x$45 === null) ? (x$46 === null) : x$45.f(x$46));
    } else {
      var $x_9 = false;
    }
    if ($x_9) {
      var x$47 = this.d6;
      var x$48 = x$0.d6;
      var $x_8 = ((x$47 === null) ? (x$48 === null) : x$47.f(x$48));
    } else {
      var $x_8 = false;
    }
    if ($x_8) {
      var x$49 = this.cS;
      var x$50 = x$0.cS;
      var $x_7 = ((x$49 === null) ? (x$50 === null) : x$49.f(x$50));
    } else {
      var $x_7 = false;
    }
    if ($x_7) {
      var x$51 = this.d8;
      var x$52 = x$0.d8;
      var $x_6 = ((x$51 === null) ? (x$52 === null) : x$51.f(x$52));
    } else {
      var $x_6 = false;
    }
    if ($x_6) {
      var x$53 = this.dc;
      var x$54 = x$0.dc;
      var $x_5 = ((x$53 === null) ? (x$54 === null) : x$53.f(x$54));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$55 = this.d5;
      var x$56 = x$0.d5;
      var $x_4 = ((x$55 === null) ? (x$56 === null) : x$55.f(x$56));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$57 = this.cX;
      var x$58 = x$0.cX;
      var $x_3 = ((x$57 === null) ? (x$58 === null) : x$57.f(x$58));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$59 = this.cQ;
      var x$60 = x$0.cQ;
      var $x_2 = ((x$59 === null) ? (x$60 === null) : x$59.f(x$60));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$61 = this.d9;
      var x$62 = x$0.d9;
      var $x_1 = ((x$61 === null) ? (x$62 === null) : x$61.f(x$62));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$63 = this.cZ;
      var x$64 = x$0.cZ;
      return ((x$63 === null) ? (x$64 === null) : x$63.f(x$64));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 33;
});
$p.t = (function() {
  return "AppDocumentDataInvoiceForm";
});
$p.e = (function(n) {
  switch (n) {
    case 0: {
      return this.cJ;
      break;
    }
    case 1: {
      return this.cK;
      break;
    }
    case 2: {
      return this.cY;
      break;
    }
    case 3: {
      return this.cW;
      break;
    }
    case 4: {
      return this.cR;
      break;
    }
    case 5: {
      return this.cD;
      break;
    }
    case 6: {
      return this.d0;
      break;
    }
    case 7: {
      return this.da;
      break;
    }
    case 8: {
      return this.d4;
      break;
    }
    case 9: {
      return this.d3;
      break;
    }
    case 10: {
      return this.d1;
      break;
    }
    case 11: {
      return this.d2;
      break;
    }
    case 12: {
      return this.cU;
      break;
    }
    case 13: {
      return this.db;
      break;
    }
    case 14: {
      return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcats_data_NonEmptyVector(this.cI);
      break;
    }
    case 15: {
      return this.cF;
      break;
    }
    case 16: {
      return this.cV;
      break;
    }
    case 17: {
      return this.cG;
      break;
    }
    case 18: {
      return this.cL;
      break;
    }
    case 19: {
      return this.cT;
      break;
    }
    case 20: {
      return this.cP;
      break;
    }
    case 21: {
      return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_data_FrameworkDate(this.cH);
      break;
    }
    case 22: {
      return this.cE;
      break;
    }
    case 23: {
      return this.d7;
      break;
    }
    case 24: {
      return this.d6;
      break;
    }
    case 25: {
      return this.cS;
      break;
    }
    case 26: {
      return this.d8;
      break;
    }
    case 27: {
      return this.dc;
      break;
    }
    case 28: {
      return this.d5;
      break;
    }
    case 29: {
      return this.cX;
      break;
    }
    case 30: {
      return this.cQ;
      break;
    }
    case 31: {
      return this.d9;
      break;
    }
    case 32: {
      return this.cZ;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.u = (function(n) {
  switch (n) {
    case 0: {
      return "number";
      break;
    }
    case 1: {
      return "recipient";
      break;
    }
    case 2: {
      return "originOfGoods";
      break;
    }
    case 3: {
      return "manufacturer";
      break;
    }
    case 4: {
      return "documentaryCredit";
      break;
    }
    case 5: {
      return "currency";
      break;
    }
    case 6: {
      return "paymentTerms";
      break;
    }
    case 7: {
      return "usuance";
      break;
    }
    case 8: {
      return "placeOfReceipt";
      break;
    }
    case 9: {
      return "placeOfLoading";
      break;
    }
    case 10: {
      return "placeOfDelivery";
      break;
    }
    case 11: {
      return "placeOfDischarge";
      break;
    }
    case 12: {
      return "incoterm";
      break;
    }
    case 13: {
      return "vesselOrFlightNumber";
      break;
    }
    case 14: {
      return "lineItems";
      break;
    }
    case 15: {
      return "freightCost";
      break;
    }
    case 16: {
      return "insuranceNumber";
      break;
    }
    case 17: {
      return "insuranceCost";
      break;
    }
    case 18: {
      return "shipmentDate";
      break;
    }
    case 19: {
      return "importer";
      break;
    }
    case 20: {
      return "consignee";
      break;
    }
    case 21: {
      return "issueDate";
      break;
    }
    case 22: {
      return "dueDate";
      break;
    }
    case 23: {
      return "shippingMarks";
      break;
    }
    case 24: {
      return "purchaseOrderReference";
      break;
    }
    case 25: {
      return "harmonizedSystemCode";
      break;
    }
    case 26: {
      return "transportDocumentNumber";
      break;
    }
    case 27: {
      return "voyage";
      break;
    }
    case 28: {
      return "preCarriageVesselOrFlightNumber";
      break;
    }
    case 29: {
      return "measurements";
      break;
    }
    case 30: {
      return "containerNumber";
      break;
    }
    case 31: {
      return "truckNumber";
      break;
    }
    case 32: {
      return "paymentDetails";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lapp_data_AppDocumentDataInvoiceForm(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.iZ)));
}
export { $isArrayOf_Lapp_data_AppDocumentDataInvoiceForm as $isArrayOf_Lapp_data_AppDocumentDataInvoiceForm };
var $d_Lapp_data_AppDocumentDataInvoiceForm = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_AppDocumentDataInvoiceForm, "app.data.AppDocumentDataInvoiceForm", ({
  iZ: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lapp_data_AppDocumentDataInvoiceForm as $d_Lapp_data_AppDocumentDataInvoiceForm };
//# sourceMappingURL=app.data.-App-Document-Data-Invoice-Form.js.map
